export function parseNumberToString(value) {
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'number') {
        return value.toString();
    }
    if (!value) {
        return value;
    }
    if (Array.isArray(value)) {
        return value.map(parseNumberToString);
    }
    if (typeof value === 'object') {
        return Object.entries(value).reduce((acc, [key, value]) => {
            acc[key] = parseNumberToString(value);
            return acc;
        }, {});
    }
    return value;
}
